<template>
  <div class="change-password-page">

    <v-text-field
      :label="$t('insertSentCode')"
      :placeholder="$t('codeEnglish')"
      v-model="sms_code"
      outlined
    ></v-text-field>

    <v-text-field
      :label="$t('insertNewPassword')"
      :placeholder="$t('passwordLatin')"
      v-model="new_pass"
      outlined
    ></v-text-field>

    <v-text-field
      :label="$t('insertRePassword')"
      :placeholder="$t('newPasswordLatin')"
      v-model="repeat_pass"
      outlined
    ></v-text-field>

    <v-btn class="save-edit-btn" v-on:click="send_sms()">{{ $t('changePassword') }}</v-btn>
  </div>

</template>
<script>
  export default {
    data () {
      return {
        user_mobile :'',
        sms_code: '',
        new_pass: '',
        repeat_pass: '',
        error: []
      }
    },
    mounted () {
      this.profile()
    },
    methods: {
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))

        this.user_id = user_data.UserId
        console.log(JSON.parse(localStorage.getItem('profile')))
        this.user_mobile = localStorage.getItem('phone')
      },
      send_sms () {
        if (this.user_mobile == '' || this.user_mobile == ' ') {
          this.error.push(this.$t('mobileIsEmpty'))
        }
        if (this.user_mobile != '') {
          const send_data = {
            MobileNo:this.user_mobile,
            UserId : this.user_id,
            SmsCode: this.sms_code,
            NewPass: this.new_pass,
            RepeatPass: this.repeat_pass
          }
          var self = this
          this.axios.post('/ChangePassword', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log(response)
                localStorage.setItem('password', self.new_pass)
              }
            }).catch(e => {

            })
        }
      }
    }

  }
</script>
